import "./MaterialsAndSurfaceFinishes.module.css";
import Header from "@/reusable_sections/Header";
import PageBreadcrumb from "@/components/common/PageBreadcrumb";
import MaterialsHero from "./sections/MaterialsHero";
import AlloyGuide from "./sections/AlloyGuide";
import Alloys from "./sections/Alloys";
import Traceability from "./sections/Traceability";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function MaterialsAndSurfaceFinishesPage() {
  return <div>
      <Header />
      <PageBreadcrumb page="MaterialsAndSurfaceFinishes" />
      <MaterialsHero />
      <AlloyGuide />
      <Alloys />
      <Traceability />
      <ClosingCta />
      <Footer />
    </div>;
}